// Modules
import styled from "styled-components";

// Styles
import {
  BodyBoldTwo,
  BodyBoldXs,
  Body,
  HeadingTwo,
} from "../../styles/common/typo.styles";

// Types
import { styledComponentProps } from "../../types/theme";

export const Card = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 407.6px;
  display: flex;
  margin: 30px 0;
  position: relative;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.16);

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    flex-direction: column-reverse;
    width: 100%;
  }
`;

export const Banner = styled.img`
  width: 779.7px;
  height: 407.6px;
  background-color: rgba(0, 0, 0, 0.2);
  object-fit: cover;

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.lg} {
    width: 70%;
  }
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
    width: 50%;
  }

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    width: 100%;
    height: 200px;
  }
`;

export const Details = styled.div<any>`
  padding: 104px 27px 12px 27px;
  display: flex;
  flex-direction: column;
  width: 380px;
  position: relative;

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    width: 100%;
    padding: 24px;
    background: ${({
      theme,
      enableColorInvert,
    }: styledComponentProps): string => {
      return enableColorInvert
        ? theme.colors.ui.darkForestGreen
        : theme.colors.ui.white;
    }};
  }
`;

export const DateView = styled.div`
  top: 20px;
  right: -10px;
  background-color: #78cde6;
  z-index: 1;
  padding: 4px 22px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: max-content;
  ${({ theme }: styledComponentProps): string =>
    theme.layout.dir === "ltr" ? "right" : "left"}: 95%;

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.md} {
    ${({ theme }: styledComponentProps): string =>
      theme.layout.dir === "ltr" ? "right" : "left"}: 90%;
  }

  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    ${({ theme }: styledComponentProps): string =>
      theme.layout.dir === "ltr" ? "right" : "left"}: 0;
    //left: unset;
    top: 10px;
  }
`;

export const H1 = styled.h1<any>`
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    color: ${({ theme, enableColorInvert }: styledComponentProps): string => {
      return enableColorInvert
        ? theme.colors.ui.white
        : theme.colors.ui.darkForestGreen;
    }};
  }
  font-size: ${({ theme }: styledComponentProps): number =>
    theme.text.size.lg}px;
  color: ${({ theme }: styledComponentProps): string =>
    theme.colors.ui.darkForestGreen};
  font-family: inherit;
  font-weight: bolder;
  line-height: 1;
  :first-letter {
    text-transform: uppercase;
  }
`;

export const H2 = styled(HeadingTwo)<any>`
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    color: ${({ theme, enableColorInvert }: styledComponentProps): string => {
      return enableColorInvert
        ? theme.colors.ui.white
        : theme.colors.ui.darkForestGreen;
    }};
  }
`;

export const P = styled(Body)<any>`
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    color: ${({ theme, enableColorInvert }: styledComponentProps): string => {
      return enableColorInvert
        ? theme.colors.ui.white
        : theme.colors.ui.darkForestGreen;
    }};
  }
`;

export const PBold = styled(BodyBoldTwo)`
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    color: ${({ theme }: styledComponentProps): string =>
      theme.colors.ui.lightBlue};
  }
`;

export const PBoldXs = styled(BodyBoldXs)`
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.sm} {
    color: ${({ theme }: styledComponentProps): string =>
      theme.colors.ui.lightBlue};
  }
`;

export const TypeView = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftArrow = styled.img<any>`
  position: absolute;
  bottom: 2rem;
  transition: 0.2s all ease-in;
  ${({ direction, hover }: styledComponentProps): string => {
    return direction === "rtl"
      ? `left: ${hover ? 1.5 : 2.5}rem;`
      : `right: ${hover ? 1.5 : 2.5}rem; transform: rotate(180deg);`;
  }}
`;

export const TextDivider = styled(BodyBoldXs)`
  padding: 0 0.25rem;
`;

export const Highlighter = styled.div`
  top: 20px;
  background-color: #78cde6;
  z-index: 1;
  padding: 4px 22px;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: max-content;
  ${({ theme }: styledComponentProps): string =>
    theme.layout.dir === 'rtl' ? 'left' : 'right'}: ${({ theme }: styledComponentProps) =>
          theme.layout.dir === 'rtl' ? '-20px' : '-20px'};
  @media ${({ theme }: styledComponentProps): string => theme.breakpoints.xl} {
    ${({ theme }: styledComponentProps): string =>
      theme.layout.dir === 'rtl' ? 'left' : 'right'}: 0;
  }
`;
